/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * One self-contained edit proposed by a suggestion, applied and reviewed on its own.
 */
export type SkillEditSuggestionChange = {
  /**
   * Whether the change still applies.
   */
  appliesCleanly: boolean;
  /**
   * When the change was recorded.
   */
  createdAt: Date;
  /**
   * Feedback records cited as the reason for this change.
   */
  feedbackCount: number;
  /**
   * Distinct sessions that reported the feedback behind this change.
   */
  feedbackSessionCount: number;
  /**
   * The change ID.
   */
  id: string;
  /**
   * The change as a unified diff against the content the changes before it produce.
   */
  proposedDiff: string;
  /**
   * Why this change alone was proposed.
   */
  rationale: string;
  /**
   * The suggestion the change belongs to.
   */
  suggestionId: string;
};

/** @internal */
export const SkillEditSuggestionChange$inboundSchema: z.ZodMiniType<
  SkillEditSuggestionChange,
  unknown
> = z.pipe(
  z.object({
    applies_cleanly: z.boolean(),
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    feedback_count: z.int(),
    feedback_session_count: z.int(),
    id: z.string(),
    proposed_diff: z.string(),
    rationale: z.string(),
    suggestion_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "applies_cleanly": "appliesCleanly",
      "created_at": "createdAt",
      "feedback_count": "feedbackCount",
      "feedback_session_count": "feedbackSessionCount",
      "proposed_diff": "proposedDiff",
      "suggestion_id": "suggestionId",
    });
  }),
);

export function skillEditSuggestionChangeFromJSON(
  jsonString: string,
): SafeParseResult<SkillEditSuggestionChange, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillEditSuggestionChange$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillEditSuggestionChange' from JSON`,
  );
}
